import Link from 'next/link';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function InfoPageBackLink() {
  return (
    <Button asChild variant="ghost" size="sm" className="mb-6">
      <Link href="/">
        <ArrowLeft className="h-4 w-4" />
        Back to Home
      </Link>
    </Button>
  );
}
